/* ─────────────────────────────────────────────────────────────────
   EquipmentFeature
   Renders a weapon or armor feature string with:
   - Feature name highlighted in gold
   - Feature body parsed for glossary term links (hover tooltip + navigation)

   Why it exists:
     Feature strings have the format "Name: description text".
     The body text may contain game terms that should link to their
     definitions in the Mechanics glossary. This component handles
     that consistently across all feature render locations in Equipment.tsx.

   How it works:
     Splits the feature string on the first colon to separate name from body.
     Renders name in gold, body via parseTextWithTerms() for term linking.

   Where it is used:
     src/pages/Equipment.tsx - weapon cards, armor cards, desktop tables
   ───────────────────────────────────────────────────────────────── */

import { parseTextWithTerms } from '../character/content/parseText';

interface EquipmentFeatureProps {
  feature: string;
}

export function EquipmentFeature({ feature }: EquipmentFeatureProps) {
  const colonIdx = feature.indexOf(':');
  if (colonIdx > 0) {
    const name = feature.substring(0, colonIdx);
    const body = feature.substring(colonIdx + 1).trim();
    return (
      <>
        <span style={{ color: 'var(--gold)', fontWeight: 600 }}>{name}:</span>
        {' '}
        {parseTextWithTerms(body)}
      </>
    );
  }
  return <>{parseTextWithTerms(feature)}</>;
}
